import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Checkbox = ({
  isSelected,
  label,
  onChange,
  type,
  value,
}) => {
  // A helper function to toggle the appropriate list ID on or off.
  const setValue = () => onChange(value, type);

  return (
    <label
      className="newsletter-item__label"
      htmlFor={`label-${value}-${type}`}
    >
      <span
        className={classNames({
          'newsletter-item__name': 'email' === type,
          'newsletter-item__label-text': 'sms' === type,
        })}
      >
        {label}
      </span>
      <input
        checked={isSelected}
        id={`label-${value}-${type}`}
        name={value}
        onChange={setValue}
        type="checkbox"
        value={value}
      />
      <span /> {/* Empty <span /> used for CSS checkmark rendering. */}
    </label>
  );
};

Checkbox.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

export default Checkbox;
